module.exports = __webpack_public_path__ + "img/logohorizontal.312e641c.svg";